import { useEffect } from 'react'

type Props = {
  to: string
}

export const NavigateExternal = ({ to }: Props) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return null
}
